<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>
        <swb-result-table class="mt10" name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>
<script>
    import { Utils, $, EventBus } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import appConf from '../../app.conf';
    import shareAccApi from '../../api/shareAcc'
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    export default {
        name: 'swb-specific-acc-list-select',
        desc: '共享库存选择个体化信息',// 用于 PC查询门店设备服务子号
        authen: false,
        avlActions: '',
        avlScopes: 'retailer',
        props: {
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            checkBox: {
                type: Boolean,
                default: false
            },
            selectIds:{
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                confKey: "swb-share-acc-specific-acc-list",
                queryOnLoad: true,
                tableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: true, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //排序、搜索
                queryConfig: {},
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            this.multiSelect = this.checkBox;
            this.multiPageSelect = this.checkBox;
            this.getSpecificAccList();
        },
        mounted() {
            let self = this;
            //
            this.initResultTable();
            this.handleInitChecked();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            //回显数据处理
            handleInitChecked() {
                let initChecked = this.selectIds;
                let resultTable = this.$refs.result_table;
                resultTable.setInitChecked(initChecked, false);
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{

                    'title': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '<span>' + row.title + '</span>';
                    },
                    'defectFlag': function (row, colName, colValue, rowIndex) {
                        if(row.defectFlag == 1) {
                            return '<span class="font-red">不良品</span>'
                        } else {
                            return '<span class="font-green">良品</span>'
                        }
                    },
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getSpecificAccList();
            },
            // 分页切换
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);

                let resultTable = this.$refs.result_table;
                console.log(resultTable.getPagination());

                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getSpecificAccList();
            },
            getSpecificAccList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems = Object.assign(filterItems, self.filter);

                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                shareAccApi.getSpecificAccListByServicerId(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let data = result.data;
                        let specificAccList = data.rows || [];
                        self.specificAccList = Utils.merge([], specificAccList);
                        self.totalCount = result.data.pagination.totalCount;
                        //
                        self.renderTable(specificAccList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let selectList = this.getTableSelection() || [];
                let result = {};
                if(selectList.length <= 0) {
                    result.type = "warn";
                    if(Utils.isTrue(this.checkBox)) {
                        result.message = "请选择至少一个个体化配件！";
                    } else {
                        result.message = "请选择配件！";
                    }
                } else {
                    result.type = "info";
                    result.data = selectList;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/accStock/SpecificAccSelect.vue